/**
 * Created by Ning Jiang on 11/24/2016.
 */
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";


export class DungeonQuestSound implements ISoundConfig {


    public static instance:DungeonQuestSound = new DungeonQuestSound();
    public AS_WIN:string="asWin";
    public AS_WIN_BIG:string="asWinBig";
    public MAIN_GAME_AMBIANCE:string = "backgroundMusicMain";
    public FREESPIN_AMBIANCE:string = "backgroundMusicRespin";


    REELS_SPINNING:string = "reelsSpinning";


    REELS_DEFAULT_BOUNCE:string[] = [
        "reelLanding1",
        "reelLanding2",
        "reelLanding3",
        "reelLanding4",
        "reelLanding5"
    ];

    public static COUNT_UP_END:string = "countUpEnds";
    public static COUNT_UP_LOOP:string = "countUpLoop";

    static BIG_WIN_SOUND:string = "bigwin";
    public static BIG_WIN_LAND:string = "";
    static BIG_WIN_END:string = "bigwinEnds";


    static WIN_REEL_HIT:string = "winHit";
    static WIN_WINDUP:string = "winStart";
    static BIG_WIN_WINDUP:string = "bigWinStart";

    static TINY_WIN:string = "winTiny";
    static SMALL_WIN:string = "winSmall";
    static MEDIUM_WIN:string = "winMedium";
    static LARGE_WIN:string = "winLarge";

    static RANDOM_WILD_INTRO:string = "randomWildIntro";
    static RANDOM_WILD_INTRO_EXPLOSION:string = "randomWildExplosion";
    static RANDOM_WILD_BUILD_UP:string = "randomWildBuildUp";
    static RANDOM_WILD_COLOSSAL_LAND:string = "randomWildColossalLand";
    static RANDOM_WILD_RUMBLE:string = "randomWildRumble";
    static RANDOM_WILD_CRACK:string = "randomWildCrack";

    static TRANSFORM_SYMBOL_LAND_ATTENTION_1:string = "transformAttention1";
    static TRANSFORM_SYMBOL_LAND_ATTENTION_2:string = "transformAttention2";
    static TRANSFORM_SYMBOL_LAND_ATTENTION_3:string = "transformAttention3";
    static TRANSFORM_SYMBOL_LAND_ATTENTION_4:string = "transformAttention4";
    static TRANSFORM_SYMBOL_LAND_ATTENTION_5:string = "transformAttention5";

    static TRANSFORM_REEL_LANDING_NORMAL:string = "reelLandingHard";
    static TRANSFORM_REEL_LANDING_LAST_REEL:string = "reelLandingHardReel5";


    static RANDOM_TRANSFORM_SYMBOL:string = "randomTransformIntroSymbol";
    static RANDOM_TRANSFORM_INTRO_L1:string = "randomTransformIntroL1";
    static RANDOM_TRANSFORM_INTRO_L2:string = "randomTransformIntroL2";
    static RANDOM_TRANSFORM_INTRO_L3:string = "randomTransformIntroL3";
    static RANDOM_TRANSFORM_INTRO_L4:string = "randomTransformIntroL4";


    static TRANSFORM_SHOCK_WAVE:string = "transformShockWave";

    static SCATTER_ATTENTION:string = "scatterAttention";
    static SCATTER_WIN:string = "scatterWin";

    static ANTICIPATION_TRANSFORM_REEL:string = "anticipationWroom";
    static ANTICIPATION_TRANSFORM_RISER:string = "anticipationLong";

    static ANTICIPATION_SCATTER:string = "anticipationScatter";
    static ANTICIPATION_SCATTER_FAIL:string = "anticipationScatterFail";


    static FS_INTRO:string = "fsIntro";
    static FS_TURN_WILD:string = "fsTurnWild";
    static FREE_SPIN_INTRO_SYMBOL_CHANGE:string = "fsSymbolChange";


    constructor() {
        if(DungeonQuestSound.instance) {
            throw new Error("DungeonQuestSound.constructor() - Instantiation failed: Singleton.");
        }
    }

    static getUpgradeIntroSymbolSound(symbol:string):string {
        if(symbol == "L1") {
            return DungeonQuestSound.RANDOM_TRANSFORM_INTRO_L1;
        }
        if(symbol == "L2") {
            return DungeonQuestSound.RANDOM_TRANSFORM_INTRO_L2;
        }
        if(symbol == "L3") {
            return DungeonQuestSound.RANDOM_TRANSFORM_INTRO_L3;
        }
        if(symbol == "L4") {
            return DungeonQuestSound.RANDOM_TRANSFORM_INTRO_L4;
        }

        return "";
    }
}